import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from './Table';
import { Api } from '../api';
import { Space } from 'antd';
//import { CategoriesFilter } from './CategoriesFilter';
import BasicTableFilter from './BasicTableFilter';




const columns = [
    {
        title: "id",
        sorter: true,
        dataIndex: "_id",
        width: '20%',
        key: "_id",
        render: (text: string) => {
            return (<Link to={`/dataImports/update/${text}`}>{text}</Link>)
        }
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: "type",
        sorter: true,
        width: '20%',
    },
];

const DataImportTable = () => {
    return (
        <Space style={{ width: '100%' }} direction="vertical">
            <Table
                tableId={ "dataImportsTable" }
              deleteApiCall={Api.dataImports.delete}
                allowDelete={true}
                restoreApiCall={Api.dataImports.restore}
                actions={(record: any) => (
                    <Link to={`/dataImports/update/${record._id}`}>View</Link>
                )}
                Filter={BasicTableFilter}
             apiCall={Api.dataImports.table} columns={columns} />
        </Space>
    )
};

export default DataImportTable;